import { WORDPRESS_API } from "shared/constants/api";

export const erasmusProject = {
  id: "erasmus",

  title: "Erasmus+ Praktyki zawodowe dla uczniów",

  description:
    "Erasmus+ Praktyki zawodowe dla uczniów Technik informatyk, Technik programista, Technik żywienia i usług gastronomicznych.",

  image: {
    src: '/assets/images/school-site/erasmus/erasmus-project.png',
    alt: "Erasmus+",
    maxWidth: "480px"
  },

  location: "Kordoba, Hiszpania",

  date: "14/15.03.2026 r. – 28/29.03.2026 r.",

  deadline:
    "Komplet dokumentów należy złożyć do 05.12.2025 r. w sekretariacie szkoły."
};

export const erasmusDocuments = [
  {
    id: "formularz-zgloszeniowy",
    title: "Formularz zgłoszeniowy dla kandydatów ETS-2025",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Formularz-zgloszeniowy-dla-kandydatow_ETS-2025.pdf`
  },
  {
    id: "oswiadczenie",
    title: "Oświadczenie",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Oswiadczenie.pdf`
  },
  {
    id: "regulamin-rekrutacji",
    title: "Regulamin rekrutacji uczestników ETS-2025",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Regulamin-rekrutacji-uczestnikow_ETS-2025.pdf`
  },
  {
    id: "zgoda",
    title: "Zgoda",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Zgoda.pdf`
  }
];